// 视频时长 转换
export const formatMillisecondsToTime = (milliseconds: number): string => {
  let totalSeconds = Math.floor(milliseconds / 1000);
  let hours = Math.floor(totalSeconds / 3600);
  let minutes = Math.floor((totalSeconds % 3600) / 60);
  let seconds = totalSeconds % 60;
  let millisecondsRemainder = milliseconds % 1000;

  // 使用新变量存储格式化后的字符串，避免类型错误
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');
  const formattedMilliseconds = String(millisecondsRemainder).padStart(3, '0');

  // 使用格式化后的字符串构建最终时间表示
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

// 不显示毫秒的时间格式化函数
export const formatMillisecondsToTimeNoMs = (milliseconds: number): string => {
  let totalSeconds = Math.floor(milliseconds / 1000);
  let hours = Math.floor(totalSeconds / 3600);
  let minutes = Math.floor((totalSeconds % 3600) / 60);
  let seconds = totalSeconds % 60;

  // 使用新变量存储格式化后的字符串，避免类型错误
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');

  // 只显示分钟和秒钟（00:00格式）
  return `${formattedMinutes}:${formattedSeconds}`;
};
